export default __webpack_public_path__ + "static/media/sweet-2.d5cf1ad2.jpg";